import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, createBlock as _createBlock, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75e92002"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between px-4 py-4 border-b border-gray-100 shrink-0" }
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 24 24",
  style: {"width":"1.4rem","height":"1.4rem"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 24 24",
  style: {"width":"1.4rem","height":"1.4rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-sm font-bold uppercase tracking-wider" }
const _hoisted_9 = {
  key: 1,
  style: {"width":"3rem"}
}
const _hoisted_10 = {
  key: 0,
  class: "flex items-center gap-2 px-4 py-2 border-b border-gray-50 shrink-0"
}
const _hoisted_11 = { class: "flex-1 min-h-0 overflow-y-auto" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-center py-20 px-8"
}
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-28 h-28 rounded-full bg-gray-50 flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "56",
    height: "56",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#9ca3af",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "3",
      y1: "6",
      x2: "21",
      y2: "6"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 10a4 4 0 0 1-8 0" })
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-base mt-5" }, "Seu carrinho está vazio", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm mt-1 max-w-[260px]" }, "Adicione produtos do cardápio para começar seu pedido", -1))
const _hoisted_17 = {
  key: 1,
  class: "flex items-center gap-3 px-4 py-3 border-b border-gray-50"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#737373",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M2 7h20" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M22 7v3a2 2 0 0 1-2 2 2.7 2.7 0 0 1-2.6-1.9 2.7 2.7 0 0 1-5.2 0 2.7 2.7 0 0 1-5.2 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "flex-1 min-w-0" }
const _hoisted_23 = { class: "font-bold text-sm truncate" }
const _hoisted_24 = {
  key: 2,
  class: "px-4 py-3 border-b border-gray-50"
}
const _hoisted_25 = { class: "rounded-2xl p-4 border border-gray-100 bg-gradient-to-br from-gray-50 to-white" }
const _hoisted_26 = { class: "flex items-start gap-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "6",
    rx: "1"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 9v12M19 9v12M5 15h14" })
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "flex-1 min-w-0" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-wider text-gray-500" }, "Comanda aberta", -1))
const _hoisted_31 = { class: "text-base font-bold leading-tight mt-0.5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, "O pedido será adicionado à conta da mesa. O pagamento é feito ao final.", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 12H3M10 7l-5 5 5 5M14 5h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_34 = {
  key: 3,
  class: "px-4 py-3 space-y-3"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-gray-600" }, "Itens adicionados", -1))
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "flex-1 min-w-0" }
const _hoisted_38 = { class: "text-sm font-semibold leading-tight" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5999 7.45801L11.1666 12.8913C10.5249 13.533 9.4749 13.533 8.83324 12.8913L3.3999 7.45801",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  class: "text-sm font-bold mt-1",
  style: {"color":"var(--primary-color, #ef4444)"}
}
const _hoisted_43 = { class: "flex items-center justify-between mt-2 gap-2" }
const _hoisted_44 = { class: "flex items-center bg-gray-50 rounded-full" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  viewBox: "0 0 24 24",
  style: {"width":"1rem","height":"1rem"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19,13H5V11H19V13Z"
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "text-sm font-bold w-6 text-center" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  viewBox: "0 0 24 24",
  style: {"width":"1rem","height":"1rem"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
}, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97M18.8499 9.13989L18.1999 19.2099C18.0899 20.7799 17.9999 21.9999 15.2099 21.9999H8.7899C5.9999 21.9999 5.9099 20.7799 5.7999 19.2099L5.1499 9.13989",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 1,
  class: "mt-2 space-y-1 text-xs text-gray-500"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "font-semibold text-gray-600" }
const _hoisted_60 = { class: "ml-1" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "font-semibold text-gray-600" }
const _hoisted_63 = {
  key: 4,
  class: "px-4 py-3 border-t border-gray-50"
}
const _hoisted_64 = { class: "flex items-center gap-3" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 4A2 2 0 0 0 2 6V10C3.11 10 4 10.9 4 12A2 2 0 0 1 2 14V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V14A2 2 0 0 1 20 12C20 10.89 20.9 10 22 10V6C22 4.89 21.1 4 20 4H4Z",
    stroke: "currentColor",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_66 = { class: "text-left" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold" }, "Cupom", -1))
const _hoisted_68 = {
  key: 0,
  class: "text-xs font-bold",
  style: {"color":"var(--primary-color, #ef4444)"}
}
const _hoisted_69 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_70 = {
  class: "text-sm font-semibold",
  style: {"color":"var(--primary-color, #ef4444)"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "px-4 bg-gray-900 text-white rounded-lg text-sm font-semibold"
}, "Aplicar", -1))
const _hoisted_72 = {
  key: 5,
  class: "px-4 py-3 border-t border-gray-50"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-semibold mb-2" }, "Observações do pedido", -1))
const _hoisted_74 = {
  key: 6,
  class: "px-4 py-3 border-t border-gray-50"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-2" }, "Resumo de valores", -1))
const _hoisted_76 = { class: "space-y-1.5 text-sm" }
const _hoisted_77 = { class: "flex justify-between" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, "Subtotal", -1))
const _hoisted_79 = {
  key: 0,
  class: "flex justify-between text-emerald-600 font-medium"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Desconto", -1))
const _hoisted_81 = { class: "flex justify-between font-bold text-base pt-2 border-t border-gray-100" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24" }, null, -1))
const _hoisted_84 = { class: "px-4 py-4 border-b border-gray-50" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-3" }, "Como você quer receber?", -1))
const _hoisted_86 = { class: "space-y-2" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = {
  key: 0,
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "5",
  cy: "17",
  r: "3"
}, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "19",
  cy: "17",
  r: "3"
}, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M5 17 8 10h7l4 7" }, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10 10v3h4v-3" }, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 10V7h3" }, null, -1))
const _hoisted_94 = [
  _hoisted_89,
  _hoisted_90,
  _hoisted_91,
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9 11V8a3 3 0 0 1 6 0v3M5 11h14l-1 10H6L5 11z",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { class: "flex-1" }
const _hoisted_102 = { class: "text-sm font-bold" }
const _hoisted_103 = { class: "text-xs text-gray-500 mt-0.5" }
const _hoisted_104 = {
  key: 0,
  class: "w-2.5 h-2.5 rounded-full bg-gray-900"
}
const _hoisted_105 = {
  key: 0,
  class: "px-4 py-4 border-b border-gray-50"
}
const _hoisted_106 = { class: "flex items-center justify-between mb-3" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-gray-600" }, "Endereço de entrega", -1))
const _hoisted_108 = {
  key: 0,
  class: "rounded-2xl overflow-hidden border border-gray-100 bg-white"
}
const _hoisted_109 = {
  key: 0,
  class: "relative h-32 bg-gray-100"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 pointer-events-none flex items-center justify-center z-[5]" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "32",
    height: "40",
    viewBox: "0 0 40 48",
    fill: "none",
    class: "-mt-3 drop-shadow-md"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20 0C8.95 0 0 8.95 0 20c0 14 20 28 20 28s20-14 20-28C40 8.95 31.05 0 20 0z",
      fill: "var(--primary-color, #ef4444)"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "20",
      cy: "20",
      r: "6.5",
      fill: "#fff"
    })
  ])
], -1))
const _hoisted_111 = { class: "flex gap-3 items-start p-3" }
const _hoisted_112 = {
  key: 0,
  class: "w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center shrink-0"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 13.43a3.12 3.12 0 1 0 0-6.24 3.12 3.12 0 0 0 0 6.24z",
    stroke: "#525252",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.62 8.49C5.59 -.16 18.42 -.15 20.38 8.5c1.15 5.07-2 9.36-4.77 12.01a5.2 5.2 0 0 1-7.22 0C5.62 17.85 2.47 13.56 3.62 8.49z",
    stroke: "#525252",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "flex-1 text-sm min-w-0" }
const _hoisted_116 = { class: "font-semibold" }
const _hoisted_117 = {
  key: 0,
  class: "text-gray-500 text-xs"
}
const _hoisted_118 = { class: "text-gray-500 text-xs" }
const _hoisted_119 = {
  key: 1,
  class: "text-gray-400 text-xs mt-0.5"
}
const _hoisted_120 = {
  key: 2,
  class: "text-gray-400 text-xs italic mt-0.5"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "7",
    stroke: "currentColor",
    "stroke-width": "1.8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 21l-4.35-4.35",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold" }, "Buscar endereço"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Digite para encontrar no mapa")
], -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  class: "text-gray-300"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9 6l6 6-6 6",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_125 = {
  key: 2,
  class: "space-y-2 mt-2"
}
const _hoisted_126 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_127 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_128 = { class: "flex gap-2 pt-1" }
const _hoisted_129 = { class: "px-4 py-4 border-b border-gray-50" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-3" }, "Quando?", -1))
const _hoisted_131 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_132 = {
  key: 0,
  class: "mt-4 space-y-4"
}
const _hoisted_133 = {
  key: 0,
  class: "p-3 rounded-xl bg-amber-50 border border-amber-100 text-xs text-amber-800 flex items-start gap-2"
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  class: "shrink-0 mt-0.5"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    stroke: "currentColor",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 8v4M12 16h.01",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhum dia disponível para agendamento nos próximos 7 dias.", -1))
const _hoisted_136 = [
  _hoisted_134,
  _hoisted_135
]
const _hoisted_137 = { key: 1 }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-semibold text-gray-500 mb-2 block" }, "Dia", -1))
const _hoisted_139 = { class: "day-scroller-wrapper relative -mx-4" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = { class: "text-[10px] uppercase tracking-wide text-gray-500 font-semibold" }
const _hoisted_142 = { class: "text-xl font-bold mt-1" }
const _hoisted_143 = { class: "text-[10px] text-gray-400" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shrink-0 w-4",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_145 = {
  class: "pointer-events-none absolute top-0 bottom-1 right-0 w-10 bg-gradient-to-l from-white via-white/80 to-transparent",
  "aria-hidden": "true"
}
const _hoisted_146 = {
  class: "pointer-events-none absolute top-0 bottom-1 left-0 w-6 bg-gradient-to-r from-white via-white/80 to-transparent",
  "aria-hidden": "true"
}
const _hoisted_147 = { key: 2 }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-semibold text-gray-500 mb-2 block" }, "Horário", -1))
const _hoisted_149 = { class: "flex items-center justify-center gap-3 bg-gray-50 rounded-xl p-3" }
const _hoisted_150 = { class: "flex flex-col items-center gap-1" }
const _hoisted_151 = ["disabled"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 15l5-5 5 5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = { class: "text-3xl font-bold w-14 text-center tabular-nums" }
const _hoisted_155 = ["disabled"]
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 9l5 5 5-5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-3xl font-bold pb-1" }, ":", -1))
const _hoisted_159 = { class: "flex flex-col items-center gap-1" }
const _hoisted_160 = ["disabled"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 15l5-5 5 5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = { class: "text-3xl font-bold w-14 text-center tabular-nums" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 9l5 5 5-5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_166 = [
  _hoisted_165
]
const _hoisted_167 = {
  key: 0,
  class: "text-xs text-gray-400 mt-2 text-center"
}
const _hoisted_168 = {
  key: 1,
  class: "text-[11px] text-gray-400 mt-2 text-center"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24" }, null, -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-4 pt-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-xs font-bold uppercase tracking-wider",
    style: {"color":"var(--primary-color, #ef4444)"}
  }, "Pagar na entrega"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, "O pagamento será realizado quando o pedido chegar.")
], -1))
const _hoisted_171 = { class: "px-4 pb-2 space-y-2" }
const _hoisted_172 = ["onClick"]
const _hoisted_173 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5098 5.01L14.5498 3.05C13.1498 1.65 10.8498 1.65 9.44977 3.05L7.48977 5.01C7.09977 5.4 7.09977 6.04 7.48977 6.43L11.2998 10.24C11.6898 10.63 12.3198 10.63 12.7098 10.24L16.5198 6.43C16.8998 6.04 16.8998 5.4 16.5098 5.01Z",
  fill: "#32BCAD"
}, null, -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.01 7.49L3.05 9.45C1.65 10.85 1.65 13.15 3.05 14.55L5.01 16.51C5.4 16.9 6.03 16.9 6.42 16.51L10.23 12.7C10.62 12.31 10.62 11.68 10.23 11.29L6.43 7.49C6.04 7.1 5.4 7.1 5.01 7.49Z",
  fill: "#32BCAD"
}, null, -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M20.95 9.45L18.99 7.49C18.6 7.1 17.97 7.1 17.58 7.49L13.77 11.3C13.38 11.69 13.38 12.32 13.77 12.71L17.58 16.52C17.97 16.91 18.6 16.91 18.99 16.52L20.95 14.56C22.35 13.15 22.35 10.85 20.95 9.45Z",
  fill: "#32BCAD"
}, null, -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.49005 18.99L9.45005 20.95C10.8501 22.35 13.1501 22.35 14.5501 20.95L16.5101 18.99C16.9001 18.6 16.9001 17.97 16.5101 17.58L12.7001 13.77C12.3101 13.38 11.6801 13.38 11.2901 13.77L7.48005 17.58C7.10005 17.96 7.10005 18.6 7.49005 18.99Z",
  fill: "#32BCAD"
}, null, -1))
const _hoisted_178 = [
  _hoisted_174,
  _hoisted_175,
  _hoisted_176,
  _hoisted_177
]
const _hoisted_179 = {
  key: 1,
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "5",
  width: "20",
  height: "14",
  rx: "2",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M2 10h20",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_182 = [
  _hoisted_180,
  _hoisted_181
]
const _hoisted_183 = {
  key: 2,
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "5",
  width: "20",
  height: "14",
  rx: "2",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M2 10h20",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "7",
  cy: "15",
  r: "1.2",
  fill: "currentColor"
}, null, -1))
const _hoisted_187 = [
  _hoisted_184,
  _hoisted_185,
  _hoisted_186
]
const _hoisted_188 = {
  key: 3,
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "2",
  y: "6",
  width: "20",
  height: "12",
  rx: "2",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "2.5",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_191 = [
  _hoisted_189,
  _hoisted_190
]
const _hoisted_192 = { class: "flex-1 min-w-0" }
const _hoisted_193 = { class: "text-sm font-bold" }
const _hoisted_194 = { class: "text-xs text-gray-500 mt-0.5 truncate" }
const _hoisted_195 = {
  key: 0,
  class: "w-2.5 h-2.5 rounded-full bg-gray-900"
}
const _hoisted_196 = {
  key: 0,
  class: "mx-4 my-3 rounded-xl border border-emerald-100 bg-emerald-50/50 overflow-hidden"
}
const _hoisted_197 = { class: "flex items-center justify-between p-3 cursor-pointer" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-lg bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "2",
        y: "6",
        width: "20",
        height: "12",
        rx: "2",
        stroke: "currentColor",
        "stroke-width": "1.6"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "2.5",
        stroke: "currentColor",
        "stroke-width": "1.6"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-gray-900" }, "Precisa de troco?"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-0.5" }, "Informe o valor que vai pagar")
  ])
], -1))
const _hoisted_199 = { class: "relative inline-flex items-center shrink-0" }
const _hoisted_200 = ["checked"]
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-emerald-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:border-gray-300 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-white" }, null, -1))
const _hoisted_202 = {
  key: 0,
  class: "px-3 pb-3 pt-3 space-y-2 border-t border-emerald-100/70 bg-white/70"
}
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-xs text-gray-600 font-semibold" }, "Troco para quanto?", -1))
const _hoisted_204 = { class: "flex items-center gap-2 bg-white rounded-lg border border-emerald-200 px-3 py-2 focus-within:border-emerald-400 transition-colors" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500 font-semibold" }, "R$", -1))
const _hoisted_206 = ["value"]
const _hoisted_207 = {
  key: 0,
  class: "text-xs text-emerald-600 font-semibold"
}
const _hoisted_208 = {
  key: 1,
  class: "text-xs text-red-500 font-semibold"
}
const _hoisted_209 = { class: "px-4 py-4 mt-2 border-t border-gray-50" }
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-3" }, "Revisão do pedido", -1))
const _hoisted_211 = { class: "space-y-2 text-sm" }
const _hoisted_212 = { class: "flex items-center justify-between" }
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Tipo", -1))
const _hoisted_214 = { class: "font-semibold" }
const _hoisted_215 = { class: "flex items-center justify-between" }
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Quando", -1))
const _hoisted_217 = { class: "font-semibold" }
const _hoisted_218 = {
  key: 0,
  class: "flex items-start justify-between gap-2"
}
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 shrink-0" }, "Endereço", -1))
const _hoisted_220 = { class: "font-semibold text-right text-xs" }
const _hoisted_221 = { class: "flex items-center justify-between pt-2 border-t border-gray-100" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Subtotal", -1))
const _hoisted_223 = {
  key: 1,
  class: "flex items-center justify-between text-emerald-600 font-medium"
}
const _hoisted_224 = { class: "flex items-center justify-between font-bold text-base pt-2 border-t border-gray-100" }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24" }, null, -1))
const _hoisted_227 = {
  key: 1,
  class: "cart-footer border-t border-gray-100 bg-white px-4 py-3 shrink-0"
}
const _hoisted_228 = { class: "flex items-center justify-between mb-3" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Total", -1))
const _hoisted_230 = { class: "text-xl font-bold" }
const _hoisted_231 = { class: "text-xs text-gray-500" }
const _hoisted_232 = ["disabled"]
const _hoisted_233 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M8.59 16.58L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.58Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_235 = [
  _hoisted_234
]
const _hoisted_236 = {
  key: 0,
  class: "text-xs text-gray-500 text-center mt-2"
}

import { watch, ref, computed, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { cart, restaurant, addOns, deliveryType, paymentMethod, changeAmount, orderTiming, scheduledAt, cmFirebaseToken, apiBaseUrl, appliedCoupon } from '@/global/state/GlobalState'
import { customer, isAuthModalOpen } from '@/global/state/AuthState'
import axiosClient from '@/api/axios'
import { useToast } from 'vue-toastification'
import { CouponModel } from '@/models/CouponModel'
import CentralLoader from '@/components/loaders/CentralLoader.vue'
import { isQrcodeReaderOpen } from '@/global/state/ModalState'
import AddressSearchModal from '@/components/address/AddressSearchModal.vue'
import { loadLeaflet } from '@/composables/useLeafletMap'


export default /*#__PURE__*/_defineComponent({
  __name: 'CartSidebar',
  props: {
    isOpen: { type: Boolean, required: true },
    setIsOpen: { type: Function, required: true },
    setIsAuthModalOpen: { type: Function, required: true }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "05331876": (_unref(restaurant).restaurantDesignCustom?.primaryColor ?? '#ef4444')
}))

const couponCode = ref<string>('')
const notes = ref<string>('')
const openCouponForm = ref<boolean>(false)
const isPlacingOrder = ref<boolean>(false)
const toast = useToast()
const showAddressForm = ref(false)
const step = ref<1 | 2 | 3>(1)
const tableNumber = ref<string | null>(localStorage.getItem('table_number'))
const isOnTab = computed(() => {
    const v = tableNumber.value
    return !!v && !isNaN(parseInt(v))
})

function leaveTab() {
    if (!window.confirm('Sair da comanda? Você poderá escolher entrega/retirada e a forma de pagamento.')) return
    localStorage.removeItem('table_number')
    tableNumber.value = null
    step.value = 1
}

function onStorageChange(e: StorageEvent) {
    if (e.key === 'table_number') {
        tableNumber.value = e.newValue
    }
}

watch(isOnTab, (onTab) => {
    if (onTab && step.value !== 1) step.value = 1
})

const stepTitle = computed(() => {
    if (step.value === 1) return 'Carrinho'
    if (step.value === 2) return 'Entrega'
    return 'Pagamento'
})

/* global defineProps */
// eslint-disable-next-line no-undef
const props = __props

const paymentMethods = [
    { value: 'pix', label: 'PIX', description: 'Pagamento instantâneo' },
    { value: 'credit_card', label: 'Cartão de crédito', description: 'Visa, Master, Elo, etc.' },
    { value: 'debit_card', label: 'Cartão de débito', description: 'Pagamento à vista' },
    { value: 'cash', label: 'Dinheiro', description: 'Pagamento na entrega' }
]

const enabledOrderTypes = computed<string[]>(() => {
    const fromConfig = (restaurant.value as any)?.restaurantConfig?.enabledOrderTypes
    if (Array.isArray(fromConfig) && fromConfig.length > 0) return fromConfig
    // Backward-compat: se o backend ainda não retornar, libera tudo
    return ['delivery', 'pick_up', 'waiter']
})

const deliveryTypes = computed(() => {
    const types: { value: string; label: string; description: string; icon: string }[] = []
    if (enabledOrderTypes.value.includes('delivery')) {
        types.push({ value: 'delivery', label: 'Entrega', description: 'Receba no endereço', icon: 'delivery' })
    }
    if (enabledOrderTypes.value.includes('pick_up')) {
        types.push({ value: 'balcao', label: 'Retirar na loja', description: 'Pegue no balcão', icon: 'pickup' })
    }
    if (enabledOrderTypes.value.includes('waiter')) {
        types.push({ value: 'presencial', label: 'No local', description: 'Estou na mesa', icon: 'waiter' })
    }
    return types
})

const designCustomLogo = computed(() => {
    return (restaurant.value as any)?.restaurantDesignCustom?.logo
})

const restaurantLogo = computed(() => {
    if ((restaurant.value as any)?.thumbnail) {
        return `${apiBaseUrl}/storage/${(restaurant.value as any).thumbnail}`
    }
    if (designCustomLogo.value) return designCustomLogo.value
    return '/assets/no-image.png'
})

function selectDeliveryType(value: string) {
    deliveryType.value = value
    localStorage.setItem('deliveryType', value)
}

function selectPaymentMethod(value: string) {
    paymentMethod.value = value
    localStorage.setItem('paymentMethod', value)
    if (value !== 'cash') {
        changeAmount.value = null
    }
}

function clearCart() {
    cart.value = []
    localStorage.removeItem('cart')
}

function hasCustomizations(product: any) {
    const variations = product.variations
    const hasVariations = typeof variations === 'string' ? JSON.parse(variations).length : (variations?.length || 0)
    const hasAddOnGroups = product.addonGroups?.length || product.addon_groups?.length
    return hasVariations || hasAddOnGroups
}

function normalizeVariations(variations: any) {
    if (!variations) return []
    try {
        return typeof variations === 'string' ? JSON.parse(variations) : variations
    } catch {
        return []
    }
}

function getCartItemImage(product: any) {
    if (product.smallImage?.path) return apiBaseUrl + '/storage/' + product.smallImage.path
    if (product.small_image?.path) return apiBaseUrl + '/storage/' + product.small_image.path
    if (product.media?.[0]?.source) {
        return product.media[0].source.startsWith('http')
            ? product.media[0].source
            : apiBaseUrl + '/storage/' + product.media[0].source
    }
    return '/assets/no-image.png'
}

const scheduledDate = ref<string>('')
const scheduledTime = ref<string>('')

watch([scheduledDate, scheduledTime], ([d, t]) => {
    scheduledAt.value = d && t ? `${d}T${t}:00` : null
})


function toLocalDateString(d: Date) {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
}

const weekdayShort = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
const monthShort = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']

const weekdayKeyByJsDay: Record<number, string> = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
}

function parseTimeToMinutes(t: string | undefined): number | null {
    if (!t || typeof t !== 'string') return null
    const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(t)
    if (!m) return null
    return parseInt(m[1], 10) * 60 + parseInt(m[2], 10)
}

function businessHoursForDate(dateStr: string): { isOpen: boolean; opensAt?: string; closesAt?: string } {
    if (!dateStr) return { isOpen: true }
    const [y, mo, dy] = dateStr.split('-').map(Number)
    const d = new Date(y, (mo || 1) - 1, dy || 1)
    const key = weekdayKeyByJsDay[d.getDay()]
    const bh = (restaurant.value as any)?.restaurantConfig?.businessHours
    if (!bh || typeof bh !== 'object') return { isOpen: true }
    const entry = bh[key]
    if (!entry || typeof entry !== 'object') return { isOpen: true }
    return {
        isOpen: !!entry.isOpen,
        opensAt: entry.opensAt,
        closesAt: entry.closesAt
    }
}

const availableDays = computed(() => {
    const days: { value: string; weekday: string; day: string; month: string; isOpen: boolean }[] = []
    const base = new Date()
    base.setHours(0, 0, 0, 0)
    for (let i = 0; i < 7; i++) {
        const d = new Date(base)
        d.setDate(base.getDate() + i)
        const value = toLocalDateString(d)
        const bh = businessHoursForDate(value)
        if (!bh.isOpen) continue
        days.push({
            value,
            weekday: i === 0 ? 'Hoje' : i === 1 ? 'Amanhã' : weekdayShort[d.getDay()],
            day: String(d.getDate()).padStart(2, '0'),
            month: monthShort[d.getMonth()],
            isOpen: true
        })
    }
    return days
})

const dayOpenWindow = computed(() => {
    const bh = businessHoursForDate(scheduledDate.value)
    if (!bh.isOpen) return { opens: 0, closes: 23 * 60 + 55 }
    const opens = parseTimeToMinutes(bh.opensAt) ?? 0
    const closes = parseTimeToMinutes(bh.closesAt) ?? (23 * 60 + 55)
    return { opens, closes }
})

const minTimeMinutes = computed(() => {
    if (!scheduledDate.value) return 0
    const window = dayOpenWindow.value
    const todayStr = toLocalDateString(new Date())
    if (scheduledDate.value === todayStr) {
        const now = new Date()
        const earliest = Math.ceil((now.getHours() * 60 + now.getMinutes() + 30) / 5) * 5
        return Math.max(window.opens, earliest)
    }
    return window.opens
})

const maxTimeMinutes = computed(() => dayOpenWindow.value.closes)

const dayOpenWindowLabel = computed(() => {
    if (!scheduledDate.value) return ''
    const bh = businessHoursForDate(scheduledDate.value)
    if (!bh.isOpen || !bh.opensAt || !bh.closesAt) return ''
    return `${bh.opensAt} às ${bh.closesAt}`
})

const currentTimeMinutes = computed(() => {
    if (!scheduledTime.value) return -1
    const [h, m] = scheduledTime.value.split(':').map(Number)
    return h * 60 + m
})

const canIncreaseTime = computed(() => currentTimeMinutes.value < maxTimeMinutes.value)
const canDecreaseTime = computed(() => currentTimeMinutes.value > minTimeMinutes.value)

const hourDisplay = computed(() => {
    if (!scheduledTime.value) return '--'
    return scheduledTime.value.split(':')[0]
})
const minuteDisplay = computed(() => {
    if (!scheduledTime.value) return '--'
    return scheduledTime.value.split(':')[1]
})

function setTimeFromMinutes(total: number) {
    total = Math.max(minTimeMinutes.value, Math.min(maxTimeMinutes.value, total))
    const h = Math.floor(total / 60)
    const m = total % 60
    scheduledTime.value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

function adjustTime(unit: 'hour' | 'minute', delta: number) {
    if (!scheduledTime.value) {
        setTimeFromMinutes(minTimeMinutes.value)
        return
    }
    const next = currentTimeMinutes.value + (unit === 'hour' ? delta * 60 : delta)
    setTimeFromMinutes(next)
}

function enableScheduled() {
    orderTiming.value = 'scheduled'
    if (!scheduledDate.value) {
        const first = availableDays.value[0]
        scheduledDate.value = first ? first.value : toLocalDateString(new Date())
    }
    if (!scheduledTime.value) {
        setTimeFromMinutes(minTimeMinutes.value)
    }
    nextTick(() => updateDayScrollIndicators())
}

const dayScroller = ref<HTMLElement | null>(null)
const dayCanScrollLeft = ref(false)
const dayCanScrollRight = ref(false)

function updateDayScrollIndicators() {
    const el = dayScroller.value
    if (!el) {
        dayCanScrollLeft.value = false
        dayCanScrollRight.value = false
        return
    }
    dayCanScrollLeft.value = el.scrollLeft > 4
    dayCanScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth - 4
}

watch(orderTiming, async (val) => {
    if (val === 'scheduled') {
        await nextTick()
        updateDayScrollIndicators()
    }
})

onMounted(() => {
    nextTick(() => updateDayScrollIndicators())
    window.addEventListener('resize', updateDayScrollIndicators)
    window.addEventListener('storage', onStorageChange)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateDayScrollIndicators)
    window.removeEventListener('storage', onStorageChange)
})

watch(scheduledDate, () => {
    if (!scheduledTime.value) return
    if (currentTimeMinutes.value < minTimeMinutes.value || currentTimeMinutes.value > maxTimeMinutes.value) {
        setTimeFromMinutes(minTimeMinutes.value)
    }
})

const savedAddresses = ref<any[]>(JSON.parse(localStorage.getItem('saved_addresses') || '[]'))

const deliveryAddress = ref({
    zipCode: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    reference: '',
    lat: null as number | null,
    lng: null as number | null,
    ...(savedAddresses.value.length ? savedAddresses.value[0] : {})
})

const isAddressSearchOpen = ref(false)

function openAddressSearch() {
    isAddressSearchOpen.value = true
}

function onAddressSelected(addr: any) {
    deliveryAddress.value = {
        zipCode: addr.zipCode || '',
        street: addr.street || '',
        number: addr.number || '',
        complement: addr.complement || '',
        neighborhood: addr.neighborhood || '',
        city: addr.city || '',
        state: addr.state || '',
        reference: addr.reference || '',
        lat: addr.lat ?? null,
        lng: addr.lng ?? null
    }
    const existing = savedAddresses.value.findIndex((a: any) =>
        a.street === deliveryAddress.value.street &&
        a.number === deliveryAddress.value.number &&
        a.city === deliveryAddress.value.city
    )
    if (existing >= 0) {
        savedAddresses.value[existing] = { ...deliveryAddress.value }
    } else {
        savedAddresses.value.unshift({ ...deliveryAddress.value })
    }
    localStorage.setItem('saved_addresses', JSON.stringify(savedAddresses.value))
    isAddressSearchOpen.value = false
    showAddressForm.value = false
}

function onAddressManual() {
    isAddressSearchOpen.value = false
    showAddressForm.value = true
}

const cartMapEl = ref<HTMLDivElement | null>(null)
let cartMap: any = null

async function renderCartMapPreview() {
    const lat = deliveryAddress.value.lat
    const lng = deliveryAddress.value.lng
    if (lat === null || lng === null || lat === undefined || lng === undefined) return
    if (!cartMapEl.value) return
    try {
        await loadLeaflet()
    } catch {
        return
    }
    const L = (window as any).L
    if (!L || !cartMapEl.value) return

    if (cartMap) {
        try { cartMap.remove() } catch { /* noop */ }
        cartMap = null
    }
    cartMap = L.map(cartMapEl.value, {
        center: [lat, lng],
        zoom: 17,
        zoomControl: false,
        attributionControl: false,
        dragging: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        touchZoom: false,
        boxZoom: false,
        keyboard: false,
        tap: false
    })
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19
    }).addTo(cartMap)
}

watch(
    () => [deliveryAddress.value.lat, deliveryAddress.value.lng, showAddressForm.value, step.value],
    async () => {
        await nextTick()
        if (step.value === 2 && !showAddressForm.value && deliveryAddress.value.lat && deliveryAddress.value.lng) {
            renderCartMapPreview()
        } else if (cartMap) {
            try { cartMap.remove() } catch { /* noop */ }
            cartMap = null
        }
    },
    { deep: true }
)

const fetchAddressByCep = async () => {
    const cep = deliveryAddress.value.zipCode?.replace(/\D/g, '')
    if (cep?.length === 8) {
        try {
            const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
            const data = await res.json()
            if (!data.erro) {
                deliveryAddress.value.street = data.logradouro || ''
                deliveryAddress.value.neighborhood = data.bairro || ''
                deliveryAddress.value.city = data.localidade || ''
                deliveryAddress.value.state = data.uf || ''
            }
        } catch { /* ignore */ }
    }
}

const saveAddress = () => {
    if (!deliveryAddress.value.street || !deliveryAddress.value.number || !deliveryAddress.value.neighborhood || !deliveryAddress.value.city || !deliveryAddress.value.state) {
        toast.warning('Preencha os campos obrigatórios do endereço', { timeout: 2000 })
        return
    }
    const addr = { ...deliveryAddress.value }
    const existing = savedAddresses.value.findIndex((a: any) => a.zipCode === addr.zipCode && a.number === addr.number)
    if (existing >= 0) {
        savedAddresses.value[existing] = addr
    } else {
        savedAddresses.value.unshift(addr)
    }
    localStorage.setItem('saved_addresses', JSON.stringify(savedAddresses.value))
    showAddressForm.value = false
    toast.success('Endereço salvo!')
}

watch(() => restaurant.value.id, () => {
    cart.value = cart.value.filter((item: any) => item.restaurant_id == restaurant.value.id)
    localStorage.setItem('cart', JSON.stringify(cart.value))
})

watch(() => props.isOpen, (newValue) => {
    document.body.style.overflow = newValue ? 'hidden' : ''
    if (newValue) {
        tableNumber.value = localStorage.getItem('table_number')
    }
    if (!newValue) {
        step.value = 1
        openCouponForm.value = false
        showAddressForm.value = false
    }
})

watch(() => cart.value, (newCart: any) => {
    localStorage.setItem('cart', JSON.stringify(newCart))
}, { deep: true })

function getProductPrice(product: any) {
    if (!product) return 0
    const qty = Number(product.quantity || 1)
    const price = Number(product.price || 0)
    const promotional = product.promotionalPrice !== undefined && product.promotionalPrice !== null ? Number(product.promotionalPrice) : null
    const discount = Number(product.discount || 0)
    const discountType = product.discountType || product.discount_type

    let basePricePerUnit = (promotional !== null) ? promotional : price

    if (promotional === null && discount > 0) {
        if (discountType === 'amount' || discountType === 'fixed') {
            basePricePerUnit = price - discount
        } else if (discountType === 'percent' || discountType === 'percentage') {
            basePricePerUnit = price - (price * (discount / 100))
        }
    }

    let totalPerUnit = basePricePerUnit

    if (product.variations) {
        try {
            const variations = typeof product.variations === 'string' ? JSON.parse(product.variations) : product.variations
            if (Array.isArray(variations)) {
                variations.forEach((variation: any) => {
                    if (variation.values && Array.isArray(variation.values.prices)) {
                        variation.values.prices.forEach((p: any) => {
                            totalPerUnit += Number(p || 0)
                        })
                    }
                })
            }
        } catch { /* ignore */ }
    }

    const addonGroups = product.addonGroups || product.addon_groups
    if (addonGroups && Array.isArray(addonGroups)) {
        addonGroups.forEach((group: any) => {
            if (group.addons && Array.isArray(group.addons)) {
                group.addons.forEach((addon: any) => {
                    const addonQty = Number(addon.quantity || 0)
                    const addonPrice = Number(addon.price || 0)
                    totalPerUnit += (addonQty * addonPrice)
                })
            }
        })
    }

    const finalTotal = totalPerUnit * qty
    return isNaN(finalTotal) ? 0 : finalTotal
}

const applyCoupon = (): void => {
    if (couponCode.value.trim()) {
        appliedCoupon.value = {
            code: couponCode.value.trim(),
            discount: 0,
            discountType: 'fixed',
            minimumPurchasePrice: 0
        } as CouponModel
        openCouponForm.value = false
    } else {
        appliedCoupon.value = null
        openCouponForm.value = false
    }
}

const totalPrice = computed<number>(() => {
    if (restaurant.value.name) {
        return cart.value.reduce((acc: number, product: any) => acc + getProductPrice(product), 0)
    }
    return 0
})

const couponDiscount = computed<number>(() => {
    if (!appliedCoupon.value) return 0
    const total = totalPrice.value
    const discount = Number(appliedCoupon.value.discount || 0)
    const discountType = appliedCoupon.value.discountType || (appliedCoupon.value as any).discount_type

    if (discountType === 'fixed' || discountType === 'amount') {
        return Math.min(discount, total)
    } else if (discountType === 'percentage' || discountType === 'percent') {
        return total * (discount / 100)
    }
    return 0
})

const canProceed = computed(() => {
    if (!cart.value.length) return false
    if (isOnTab.value) {
        if (restaurant.value.minimumOrder > totalPrice.value) return false
        return true
    }
    if (step.value === 1) {
        if (restaurant.value.minimumOrder > totalPrice.value) return false
        return true
    }
    if (step.value === 2) {
        if (!deliveryType.value) return false
        if (deliveryType.value === 'delivery' && !deliveryAddress.value.street) return false
        if (orderTiming.value === 'scheduled' && !scheduledAt.value) return false
        return true
    }
    if (step.value === 3) {
        if (!paymentMethod.value) return false
        if (paymentMethod.value === 'cash' && changeAmount.value !== null && changeAmount.value < (totalPrice.value - couponDiscount.value)) return false
        return true
    }
    return false
})

const primaryActionLabel = computed(() => {
    if (isOnTab.value) return 'Enviar para a comanda'
    if (step.value === 3) return 'Finalizar pedido'
    return 'Continuar'
})

const deliveryTypeLabel = computed(() => {
    const found = deliveryTypes.value.find(t => t.value === deliveryType.value)
    return found?.label ?? '—'
})

const orderTimingLabel = computed(() => {
    if (orderTiming.value !== 'scheduled') return 'Para agora'
    if (!scheduledAt.value) return 'Agendado'
    const [d, t] = scheduledAt.value.split('T')
    const [, m, day] = d.split('-')
    return `${day}/${m} às ${t?.slice(0, 5)}`
})

const changeAmountDisplay = computed(() => {
    if (changeAmount.value === null || changeAmount.value === undefined) return ''
    return changeAmount.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
})

function onChangeAmountInput(e: Event) {
    const target = e.target as HTMLInputElement
    const digits = target.value.replace(/\D/g, '')
    if (!digits) {
        changeAmount.value = 0
        return
    }
    changeAmount.value = parseInt(digits, 10) / 100
}

function toggleChange(enabled: boolean) {
    if (enabled) {
        const min = totalPrice.value - couponDiscount.value
        changeAmount.value = Math.ceil(min)
    } else {
        changeAmount.value = null
    }
}

function paymentMethodIconBg(value: string) {
    if (value === 'pix') return 'bg-emerald-50 text-emerald-600'
    if (value === 'cash') return 'bg-emerald-50 text-emerald-600'
    return 'bg-gray-100 text-gray-800'
}

function goBack() {
    if (step.value === 1) {
        props.setIsOpen(false)
    } else {
        step.value = (step.value - 1) as 1 | 2 | 3
    }
}

function onPrimaryAction() {
    if (!canProceed.value) return
    if (isOnTab.value) {
        if (!customer.value.cpf) {
            isAuthModalOpen.value = true
            return
        }
        placeOrder()
        return
    }
    if (step.value === 1) {
        if (!customer.value.cpf) {
            isAuthModalOpen.value = true
            return
        }
        step.value = 2
        return
    }
    if (step.value === 2) {
        step.value = 3
        return
    }
    placeOrder()
}

async function placeOrder(): Promise<void> {
    if (!customer.value.cpf) {
        isAuthModalOpen.value = true
        return
    }

    if (appliedCoupon.value && appliedCoupon.value.minimumPurchasePrice > totalPrice.value) {
        toast.warning(`O pedido mínimo do cupom é de ${appliedCoupon.value!.minimumPurchasePrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, { timeout: 1500 })
        return
    }

    const orderType = isOnTab.value ? 'presencial' : (deliveryType.value || 'presencial')

    if (orderType === 'presencial') {
        const storedTableNumber = localStorage.getItem('table_number')
        if (!storedTableNumber || isNaN(parseInt(storedTableNumber))) {
            toast.warning('Escaneie uma mesa para fazer um pedido presencial')
            isQrcodeReaderOpen.value = true
            return
        }
    }

    if (orderType === 'delivery' && !deliveryAddress.value.street) {
        toast.warning('Preencha o endereço de entrega', { timeout: 2000 })
        showAddressForm.value = true
        return
    }

    if (!isOnTab.value && orderTiming.value === 'scheduled' && !scheduledAt.value) {
        toast.warning('Selecione data e horário para o agendamento', { timeout: 2000 })
        return
    }

    if (!isOnTab.value && paymentMethod.value === 'cash' && changeAmount.value && changeAmount.value > 0) {
        const finalTotal = totalPrice.value - couponDiscount.value
        if (changeAmount.value < finalTotal) {
            toast.warning('O valor para troco deve ser maior ou igual ao total do pedido', { timeout: 2000 })
            return
        }
    }

    if (couponCode.value && appliedCoupon.value?.code != couponCode.value) {
        applyCoupon()
    }

    isPlacingOrder.value = true

    const cleanCpf = customer.value.cpf.replace(/\D/g, '')

    // O telefone pode vir com o DDI 55 já salvo (retornado pelo backend em consultas anteriores);
    // a validação da API só aceita o número local (10 ou 11 dígitos), então removemos o prefixo aqui.
    const phoneDigits = (customer.value.phone || '').replace(/\D/g, '')
    const cleanPhone = phoneDigits.length > 11 && phoneDigits.startsWith('55')
        ? phoneDigits.slice(2)
        : phoneDigits

    const products = cart.value.map((itemValue: any) => {
        const item = JSON.parse(JSON.stringify(itemValue))

        const variants: { id: number; quantity: number }[] = []
        const variations = item.variations ? (typeof item.variations === 'string' ? JSON.parse(item.variations) : item.variations) : []

        if (Array.isArray(variations)) {
            variations.forEach((v: any) => {
                if (v.values && Array.isArray(v.values.ids)) {
                    v.values.ids.forEach((id: number) => {
                        variants.push({ id, quantity: 1 })
                    })
                }
            })
        }

        const itemAddOns: { id: number; quantity: number }[] = []
        const addonGroups = item.addon_groups || item.addonGroups || []

        if (Array.isArray(addonGroups)) {
            addonGroups.forEach((group: any) => {
                if (group.addons && Array.isArray(group.addons)) {
                    group.addons.forEach((addon: any) => {
                        itemAddOns.push({ id: addon.id, quantity: addon.quantity })
                    })
                }
            })
        }

        return {
            id: item.id,
            quantity: item.quantity,
            variants,
            addOns: itemAddOns
        }
    })

    const finalTotal = totalPrice.value - couponDiscount.value

    let addressId: number | null = null
    if (orderType === 'delivery') {
        try {
            const addrRes = await axiosClient.post('customer/addresses', {
                cpf: cleanCpf,
                name: customer.value.name,
                email: customer.value.email,
                street: deliveryAddress.value.street,
                number: deliveryAddress.value.number,
                complement: deliveryAddress.value.complement || null,
                neighborhood: deliveryAddress.value.neighborhood,
                city: deliveryAddress.value.city,
                state: deliveryAddress.value.state,
                zipCode: deliveryAddress.value.zipCode || null,
                reference: deliveryAddress.value.reference || null,
                lat: deliveryAddress.value.lat ?? null,
                lng: deliveryAddress.value.lng ?? null
            })
            addressId = addrRes.data?.id ?? addrRes.data?.data?.id ?? null
        } catch (error: any) {
            const apiErrors = error.response?.data?.errors
            if (Array.isArray(apiErrors) && apiErrors.length > 0) {
                apiErrors.forEach((e: any) => toast.error(e.message))
            } else {
                toast.error('Falha ao salvar endereço')
            }
            isPlacingOrder.value = false
            return
        }
        if (!addressId) {
            toast.error('Falha ao salvar endereço')
            isPlacingOrder.value = false
            return
        }
    }

    const orderPayload: any = {
        couponCode: appliedCoupon.value?.code,
        name: customer.value.name,
        email: customer.value.email,
        cpf: cleanCpf,
        phone: cleanPhone || undefined,
        notes: notes.value,
        products,
        deliveryType: orderType,
        tabNumber: orderType === 'presencial' ? localStorage.getItem('table_number') : null,
        cmFirebaseToken: cmFirebaseToken.value,
        addressId: addressId ?? undefined
    }

    if (!isOnTab.value) {
        const payments: any[] = []
        if (paymentMethod.value) {
            const payment: any = {
                method: paymentMethod.value,
                value: finalTotal,
                type: 'offline'
            }
            if (paymentMethod.value === 'cash' && changeAmount.value && changeAmount.value > 0) {
                payment.cash = { changeFor: changeAmount.value }
            }
            payments.push(payment)
        }
        orderPayload.paymentMethod = paymentMethod.value
        orderPayload.payments = payments
        orderPayload.timing = orderTiming.value
        orderPayload.scheduled = orderTiming.value === 'scheduled' && scheduledAt.value
            ? { deliveryDateTimeStart: `${scheduledAt.value}-03:00` }
            : null
    }

    axiosClient.post('customer/orders', orderPayload).then(() => {
        props.setIsOpen(false)
        cart.value = []
        step.value = 1
        toast.success('Pedido enviado')
        localStorage.setItem('customer', JSON.stringify({ ...customer.value, is_registered: true }))
        customer.value = { ...customer.value, is_registered: true }

        // O primeiro pedido cria o cliente na API; busca o cadastro para obter o uuid,
        // que é o que permite registrar o aparelho para notificações push
        if (!customer.value.uuid && customer.value.cpf) {
            axiosClient.get(`/customer/cpf/${customer.value.cpf.replace(/\D/g, '')}`).then((res: any) => {
                const updatedCustomer = { ...customer.value, ...res.data.customer, is_registered: true }
                localStorage.setItem('customer', JSON.stringify(updatedCustomer))
                customer.value = updatedCustomer
            }).catch(() => {})
        }
    }).catch((error) => {
        const apiErrors = error.response?.data?.errors
        if (Array.isArray(apiErrors) && apiErrors.length > 0) {
            apiErrors.forEach((e: any) => toast.error(e.message))
        } else if (error.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Falha ao salvar pedido')
        }
    }).finally(() => {
        isPlacingOrder.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["cart-sidebar fixed right-0 bottom-0 top-0 flex flex-col font-inter transition-all duration-300 z-[120] transform", __props.isOpen ? 'translate-x-0 shadow-2xl' : 'translate-x-full'])
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("button", {
          onClick: goBack,
          class: "p-1 transition duration-200 hover:opacity-60"
        }, [
          (step.value === 1)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
            : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
        ]),
        _createElementVNode("h2", _hoisted_8, _toDisplayString(stepTitle.value), 1),
        (step.value === 1 && _unref(cart).length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: clearCart,
              class: "text-sm font-semibold",
              style: {"color":"var(--primary-color, #ef4444)"}
            }, "Limpar"))
          : (_openBlock(), _createElementBlock("span", _hoisted_9))
      ]),
      (!isOnTab.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 h-1 rounded-full transition-colors duration-200", step.value >= 1 ? 'bg-gray-900' : 'bg-gray-200'])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 h-1 rounded-full transition-colors duration-200", step.value >= 2 ? 'bg-gray-900' : 'bg-gray-200'])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 h-1 rounded-full transition-colors duration-200", step.value >= 3 ? 'bg-gray-900' : 'bg-gray-200'])
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("div", null, [
          (!_unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", {
                    class: "absolute -bottom-1 -right-1 w-9 h-9 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md",
                    style: _normalizeStyle({ background: 'var(--primary-color, #ef4444)', color: 'var(--sf-on-primary, #fff)' })
                  }, "+", 4)
                ]),
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.setIsOpen(false))),
                  class: "mt-6 px-6 py-3 rounded-xl text-sm font-bold text-white transition hover:opacity-90",
                  style: _normalizeStyle({ background: 'var(--primary-color, #ef4444)', color: 'var(--sf-on-primary, #fff)' })
                }, " Ver cardápio ", 4)
              ]))
            : _createCommentVNode("", true),
          (_unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_unref(restaurant).thumbnail || designCustomLogo.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: restaurantLogo.value,
                      onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png')),
                      class: "w-12 h-12 rounded-full object-cover border border-gray-100",
                      alt: ""
                    }, null, 40, _hoisted_18))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h3", _hoisted_23, _toDisplayString(_unref(restaurant).name), 1),
                  _createElementVNode("button", {
                    class: "text-xs font-semibold mt-0.5",
                    style: {"color":"var(--primary-color, #ef4444)"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.setIsOpen(false)))
                  }, "Adicionar mais itens")
                ])
              ]))
            : _createCommentVNode("", true),
          (isOnTab.value && _unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", {
                      class: "w-11 h-11 rounded-full flex items-center justify-center shrink-0",
                      style: _normalizeStyle({ background: 'color-mix(in srgb, var(--primary-color, #ef4444) 12%, transparent)', color: 'var(--primary-color, #ef4444)' })
                    }, _hoisted_28, 4),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("p", _hoisted_31, "Mesa #" + _toDisplayString(tableNumber.value), 1),
                      _hoisted_32
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: leaveTab,
                    class: "w-full mt-3 py-2 rounded-lg border border-gray-200 text-xs font-semibold text-gray-600 hover:bg-gray-50 transition flex items-center justify-center gap-2"
                  }, [
                    _hoisted_33,
                    _createTextVNode(" Sair da comanda ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _hoisted_35,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cart), (product, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.id + '-' + index,
                    class: "flex gap-3 pb-3 border-b border-gray-50 last:border-b-0"
                  }, [
                    _createElementVNode("img", {
                      src: getCartItemImage(product),
                      onError: _cache[3] || (_cache[3] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png')),
                      class: "w-16 h-16 rounded-lg object-cover bg-gray-50 shrink-0",
                      alt: ""
                    }, null, 40, _hoisted_36),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("h5", _hoisted_38, _toDisplayString(product.name), 1),
                      (hasCustomizations(product))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (product.seeMore = !product.seeMore),
                            class: "text-xs text-gray-500 hover:underline mt-1 flex items-center gap-1"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(product.seeMore ? 'Ocultar detalhes' : 'Ver detalhes'), 1),
                            (_openBlock(), _createElementBlock("svg", {
                              class: _normalizeClass([product.seeMore ? 'rotate-180' : '', "transform transition-transform"]),
                              width: "12",
                              height: "12",
                              viewBox: "0 0 20 20",
                              fill: "none"
                            }, _hoisted_41, 2))
                          ], 8, _hoisted_39))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_42, _toDisplayString(getProductPrice(product).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => {product.quantity--; product.quantity <= 0 ? _unref(cart).splice(index, 1) : ''},
                            class: "w-7 h-7 flex items-center justify-center text-gray-600 hover:text-gray-900"
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_46, _hoisted_48))
                          ], 8, _hoisted_45),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(product.quantity), 1),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (product.quantity++),
                            class: "w-7 h-7 flex items-center justify-center text-gray-600 hover:text-gray-900"
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_53))
                          ], 8, _hoisted_50)
                        ]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_unref(cart).splice(index, 1)),
                          class: "text-gray-400 hover:text-red-500 transition-colors p-1"
                        }, _hoisted_56, 8, _hoisted_54)
                      ]),
                      (product.seeMore && hasCustomizations(product))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalizeVariations(product.variations), (variation, vIdx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: vIdx }, [
                                (variation.values?.label?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createElementVNode("span", _hoisted_59, _toDisplayString(variation.name) + ":", 1),
                                      _createElementVNode("span", _hoisted_60, _toDisplayString(variation.values.label.join(', ')), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((product.addonGroups || product.addon_groups || []), (group, agIdx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: agIdx }, [
                                (group.addons?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                      _createElementVNode("div", _hoisted_62, _toDisplayString(group.name) + ":", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.addons, (addon, aIdx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: aIdx,
                                          class: "ml-2"
                                        }, _toDisplayString(addon.quantity * product.quantity) + "x " + _toDisplayString(_unref(addOns)[addon.id]?.name), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openCouponForm.value = !openCouponForm.value)),
                  class: "w-full flex items-center justify-between gap-2 py-2"
                }, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      (_unref(appliedCoupon))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(_unref(appliedCoupon).code), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_69, "Digite um código"))
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_70, _toDisplayString(openCouponForm.value ? 'Fechar' : (_unref(appliedCoupon) ? 'Alterar' : 'Digitar')), 1)
                ]),
                (openCouponForm.value)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 0,
                      onSubmit: _withModifiers(applyCoupon, ["prevent"]),
                      class: "flex gap-2 mt-2"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((couponCode).value = $event)),
                        type: "text",
                        placeholder: "ex: CUPOM30",
                        class: "flex-1 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                      }, null, 512), [
                        [_vModelText, couponCode.value]
                      ]),
                      _hoisted_71
                    ], 32))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _hoisted_73,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((notes).value = $event)),
                  rows: "2",
                  maxlength: "255",
                  placeholder: "Ex.: sem cebola, ponto da carne...",
                  class: "w-full bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400 resize-none"
                }, null, 512), [
                  [_vModelText, notes.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(cart).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("span", null, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                  ]),
                  (couponDiscount.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("span", null, "- " + _toDisplayString(couponDiscount.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("span", null, _toDisplayString((totalPrice.value - couponDiscount.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_83
        ], 512), [
          [_vShow, step.value === 1]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryTypes.value, (type) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: type.value,
                  onClick: ($event: any) => (selectDeliveryType(type.value)),
                  class: _normalizeClass(["w-full flex items-center gap-3 p-3 rounded-xl border-2 transition-all duration-150 text-left", _unref(deliveryType) === type.value ? 'border-gray-900 bg-gray-50' : 'border-gray-100 hover:border-gray-200'])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-10 h-10 rounded-full flex items-center justify-center shrink-0", _unref(deliveryType) === type.value ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-500'])
                  }, [
                    (type.icon === 'delivery')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_88, _hoisted_94))
                      : (type.icon === 'pickup')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_95, _hoisted_97))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_98, _hoisted_100))
                  ], 2),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("p", _hoisted_102, _toDisplayString(type.label), 1),
                    _createElementVNode("p", _hoisted_103, _toDisplayString(type.description), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-5 h-5 rounded-full border-2 flex items-center justify-center", _unref(deliveryType) === type.value ? 'border-gray-900' : 'border-gray-300'])
                  }, [
                    (_unref(deliveryType) === type.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_104))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 10, _hoisted_87))
              }), 128))
            ])
          ]),
          (_unref(deliveryType) === 'delivery')
            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                _createElementVNode("div", _hoisted_106, [
                  _hoisted_107,
                  (deliveryAddress.value.street && !showAddressForm.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: openAddressSearch,
                        class: "text-sm font-semibold",
                        style: {"color":"var(--primary-color, #ef4444)"}
                      }, "Trocar"))
                    : _createCommentVNode("", true)
                ]),
                (deliveryAddress.value.street && !showAddressForm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                      (deliveryAddress.value.lat && deliveryAddress.value.lng)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                            _createElementVNode("div", {
                              ref_key: "cartMapEl",
                              ref: cartMapEl,
                              class: "absolute inset-0"
                            }, null, 512),
                            _hoisted_110
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_111, [
                        (!(deliveryAddress.value.lat && deliveryAddress.value.lng))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("p", _hoisted_116, _toDisplayString(deliveryAddress.value.street) + ", " + _toDisplayString(deliveryAddress.value.number), 1),
                          (deliveryAddress.value.complement)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_117, _toDisplayString(deliveryAddress.value.complement), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_118, _toDisplayString(deliveryAddress.value.neighborhood) + " - " + _toDisplayString(deliveryAddress.value.city) + "/" + _toDisplayString(deliveryAddress.value.state), 1),
                          (deliveryAddress.value.zipCode)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_119, "CEP: " + _toDisplayString(deliveryAddress.value.zipCode), 1))
                            : _createCommentVNode("", true),
                          (deliveryAddress.value.reference)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_120, "Ref: " + _toDisplayString(deliveryAddress.value.reference), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (!showAddressForm.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: openAddressSearch,
                        class: "w-full flex items-center gap-3 p-4 rounded-xl border-2 border-dashed border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-colors text-left"
                      }, [
                        _createElementVNode("div", {
                          class: "w-10 h-10 rounded-full flex items-center justify-center shrink-0",
                          style: _normalizeStyle({ background: 'color-mix(in srgb, var(--primary-color, #ef4444) 12%, transparent)', color: 'var(--primary-color, #ef4444)' })
                        }, _hoisted_122, 4),
                        _hoisted_123,
                        _hoisted_124
                      ]))
                    : _createCommentVNode("", true),
                (showAddressForm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((deliveryAddress.value.zipCode) = $event)),
                          type: "text",
                          placeholder: "CEP",
                          class: "col-span-1 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400",
                          onBlur: fetchAddressByCep
                        }, null, 544), [
                          [_vModelText, deliveryAddress.value.zipCode]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((deliveryAddress.value.state) = $event)),
                          type: "text",
                          placeholder: "Estado",
                          maxlength: "2",
                          class: "col-span-1 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                        }, null, 512), [
                          [_vModelText, deliveryAddress.value.state]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((deliveryAddress.value.city) = $event)),
                          type: "text",
                          placeholder: "Cidade",
                          class: "col-span-1 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                        }, null, 512), [
                          [_vModelText, deliveryAddress.value.city]
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((deliveryAddress.value.street) = $event)),
                        type: "text",
                        placeholder: "Rua / Avenida",
                        class: "w-full bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                      }, null, 512), [
                        [_vModelText, deliveryAddress.value.street]
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((deliveryAddress.value.number) = $event)),
                          type: "text",
                          placeholder: "Nº",
                          class: "col-span-1 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                        }, null, 512), [
                          [_vModelText, deliveryAddress.value.number]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((deliveryAddress.value.complement) = $event)),
                          type: "text",
                          placeholder: "Complemento",
                          class: "col-span-2 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                        }, null, 512), [
                          [_vModelText, deliveryAddress.value.complement]
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((deliveryAddress.value.neighborhood) = $event)),
                        type: "text",
                        placeholder: "Bairro",
                        class: "w-full bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                      }, null, 512), [
                        [_vModelText, deliveryAddress.value.neighborhood]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((deliveryAddress.value.reference) = $event)),
                        type: "text",
                        placeholder: "Ponto de referência (opcional)",
                        class: "w-full bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400"
                      }, null, 512), [
                        [_vModelText, deliveryAddress.value.reference]
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        (deliveryAddress.value.street)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (showAddressForm.value = false)),
                              class: "flex-1 py-3 rounded-lg border border-gray-200 text-sm font-semibold text-gray-600"
                            }, "Cancelar"))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: saveAddress,
                          class: "flex-1 py-3 bg-gray-900 text-white rounded-lg text-sm font-bold"
                        }, "Salvar endereço")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_129, [
            _hoisted_130,
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (orderTiming.value = 'immediate')),
                class: _normalizeClass(["p-3 rounded-xl border-2 transition-all duration-150 text-sm font-bold", _unref(orderTiming) === 'immediate' ? 'border-gray-900 bg-gray-50 text-gray-900' : 'border-gray-100 text-gray-500 hover:border-gray-200'])
              }, " Para agora ", 2),
              _createElementVNode("button", {
                onClick: enableScheduled,
                class: _normalizeClass(["p-3 rounded-xl border-2 transition-all duration-150 text-sm font-bold", _unref(orderTiming) === 'scheduled' ? 'border-gray-900 bg-gray-50 text-gray-900' : 'border-gray-100 text-gray-500 hover:border-gray-200'])
              }, " Agendar ", 2)
            ]),
            (_unref(orderTiming) === 'scheduled')
              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                  (!availableDays.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, _hoisted_136))
                    : _createCommentVNode("", true),
                  (availableDays.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                        _hoisted_138,
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("div", {
                            ref_key: "dayScroller",
                            ref: dayScroller,
                            onScroll: updateDayScrollIndicators,
                            class: "flex gap-2 overflow-x-auto px-4 pb-1 scroll-snap-x"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDays.value, (day) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: day.value,
                                onClick: ($event: any) => (scheduledDate.value = day.value),
                                class: _normalizeClass(["shrink-0 flex flex-col items-center justify-center w-16 h-20 rounded-xl border-2 transition-all duration-150", scheduledDate.value === day.value ? 'border-gray-900 bg-gray-50' : 'border-gray-100 hover:border-gray-200'])
                              }, [
                                _createElementVNode("span", _hoisted_141, _toDisplayString(day.weekday), 1),
                                _createElementVNode("span", _hoisted_142, _toDisplayString(day.day), 1),
                                _createElementVNode("span", _hoisted_143, _toDisplayString(day.month), 1)
                              ], 10, _hoisted_140))
                            }), 128)),
                            _hoisted_144
                          ], 544),
                          _withDirectives(_createElementVNode("div", _hoisted_145, null, 512), [
                            [_vShow, dayCanScrollRight.value]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_146, null, 512), [
                            [_vShow, dayCanScrollLeft.value]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (scheduledDate.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                        _hoisted_148,
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("div", _hoisted_150, [
                            _createElementVNode("button", {
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (adjustTime('hour', 1))),
                              disabled: !canIncreaseTime.value || !scheduledTime.value,
                              class: "w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 disabled:opacity-30 hover:border-gray-400 transition-colors"
                            }, _hoisted_153, 8, _hoisted_151),
                            _createElementVNode("span", _hoisted_154, _toDisplayString(hourDisplay.value), 1),
                            _createElementVNode("button", {
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (adjustTime('hour', -1))),
                              disabled: !canDecreaseTime.value || !scheduledTime.value,
                              class: "w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 disabled:opacity-30 hover:border-gray-400 transition-colors"
                            }, _hoisted_157, 8, _hoisted_155)
                          ]),
                          _hoisted_158,
                          _createElementVNode("div", _hoisted_159, [
                            _createElementVNode("button", {
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (adjustTime('minute', 5))),
                              disabled: !canIncreaseTime.value || !scheduledTime.value,
                              class: "w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 disabled:opacity-30 hover:border-gray-400 transition-colors"
                            }, _hoisted_162, 8, _hoisted_160),
                            _createElementVNode("span", _hoisted_163, _toDisplayString(minuteDisplay.value), 1),
                            _createElementVNode("button", {
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (adjustTime('minute', -5))),
                              disabled: !canDecreaseTime.value || !scheduledTime.value,
                              class: "w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 disabled:opacity-30 hover:border-gray-400 transition-colors"
                            }, _hoisted_166, 8, _hoisted_164)
                          ])
                        ]),
                        (!scheduledTime.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_167, "Selecione um horário"))
                          : (dayOpenWindowLabel.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_168, " Horário de funcionamento: " + _toDisplayString(dayOpenWindowLabel.value), 1))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_169
        ], 512), [
          [_vShow, step.value === 2]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _hoisted_170,
          _createElementVNode("div", _hoisted_171, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentMethods, (method) => {
              return _createElementVNode("button", {
                key: method.value,
                onClick: ($event: any) => (selectPaymentMethod(method.value)),
                class: _normalizeClass(["w-full flex items-center gap-3 p-3 rounded-xl border-2 transition-all duration-150 text-left", _unref(paymentMethod) === method.value ? 'border-gray-900 bg-gray-50' : 'border-gray-100 hover:border-gray-200'])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-11 h-11 rounded-xl flex items-center justify-center shrink-0", paymentMethodIconBg(method.value)])
                }, [
                  (method.value === 'pix')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_173, _hoisted_178))
                    : (method.value === 'credit_card')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_179, _hoisted_182))
                      : (method.value === 'debit_card')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_183, _hoisted_187))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_188, _hoisted_191))
                ], 2),
                _createElementVNode("div", _hoisted_192, [
                  _createElementVNode("p", _hoisted_193, _toDisplayString(method.label), 1),
                  _createElementVNode("p", _hoisted_194, _toDisplayString(method.description), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0", _unref(paymentMethod) === method.value ? 'border-gray-900' : 'border-gray-300'])
                }, [
                  (_unref(paymentMethod) === method.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_195))
                    : _createCommentVNode("", true)
                ], 2)
              ], 10, _hoisted_172)
            }), 64))
          ]),
          (_unref(paymentMethod) === 'cash')
            ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                _createElementVNode("label", _hoisted_197, [
                  _hoisted_198,
                  _createElementVNode("span", _hoisted_199, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _unref(changeAmount) !== null,
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (toggleChange(($event.target as HTMLInputElement).checked))),
                      class: "sr-only peer"
                    }, null, 40, _hoisted_200),
                    _hoisted_201
                  ])
                ]),
                (_unref(changeAmount) !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                      _hoisted_203,
                      _createElementVNode("div", _hoisted_204, [
                        _hoisted_205,
                        _createElementVNode("input", {
                          value: changeAmountDisplay.value,
                          onInput: onChangeAmountInput,
                          type: "tel",
                          inputmode: "numeric",
                          placeholder: "0,00",
                          class: "flex-1 bg-transparent text-sm focus:outline-none font-semibold tabular-nums"
                        }, null, 40, _hoisted_206)
                      ]),
                      (_unref(changeAmount) && _unref(changeAmount) > (totalPrice.value - couponDiscount.value))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_207, " Troco a receber: " + _toDisplayString((_unref(changeAmount) - (totalPrice.value - couponDiscount.value)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1))
                        : (_unref(changeAmount) && _unref(changeAmount) < (totalPrice.value - couponDiscount.value))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_208, " Valor menor que o total do pedido "))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_209, [
            _hoisted_210,
            _createElementVNode("div", _hoisted_211, [
              _createElementVNode("div", _hoisted_212, [
                _hoisted_213,
                _createElementVNode("span", _hoisted_214, _toDisplayString(deliveryTypeLabel.value), 1)
              ]),
              _createElementVNode("div", _hoisted_215, [
                _hoisted_216,
                _createElementVNode("span", _hoisted_217, _toDisplayString(orderTimingLabel.value), 1)
              ]),
              (_unref(deliveryType) === 'delivery' && deliveryAddress.value.street)
                ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                    _hoisted_219,
                    _createElementVNode("span", _hoisted_220, _toDisplayString(deliveryAddress.value.street) + ", " + _toDisplayString(deliveryAddress.value.number), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_221, [
                _hoisted_222,
                _createElementVNode("span", null, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
              ]),
              (couponDiscount.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                    _createElementVNode("span", null, "Cupom " + _toDisplayString(_unref(appliedCoupon)?.code), 1),
                    _createElementVNode("span", null, "- " + _toDisplayString(couponDiscount.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_224, [
                _hoisted_225,
                _createElementVNode("span", null, _toDisplayString((totalPrice.value - couponDiscount.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
              ])
            ])
          ]),
          _hoisted_226
        ], 512), [
          [_vShow, step.value === 3]
        ])
      ]),
      (_unref(cart).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
            _createElementVNode("div", _hoisted_228, [
              _createElementVNode("div", null, [
                _hoisted_229,
                _createElementVNode("p", _hoisted_230, _toDisplayString((totalPrice.value - couponDiscount.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
              ]),
              _createElementVNode("p", _hoisted_231, _toDisplayString(_unref(cart).length) + " " + _toDisplayString(_unref(cart).length === 1 ? 'item' : 'itens'), 1)
            ]),
            _createElementVNode("button", {
              onClick: onPrimaryAction,
              disabled: !canProceed.value,
              class: _normalizeClass(["w-full py-4 rounded-xl font-bold text-base flex items-center justify-center gap-2 transition-all duration-200", canProceed.value ? 'text-white shadow-lg' : 'bg-gray-100 text-gray-400 cursor-not-allowed']),
              style: _normalizeStyle(canProceed.value ? { background: 'var(--primary-color, #ef4444)', color: 'var(--sf-on-primary, #fff)' } : {})
            }, [
              _createTextVNode(_toDisplayString(primaryActionLabel.value) + " ", 1),
              (canProceed.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_233, _hoisted_235))
                : _createCommentVNode("", true)
            ], 14, _hoisted_232),
            (step.value === 1 && _unref(restaurant).minimumOrder > totalPrice.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_236, " Pedido mínimo: " + _toDisplayString(_unref(restaurant).minimumOrder?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 z-[115]",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (__props.setIsOpen(false)))
        }))
      : _createCommentVNode("", true),
    (isPlacingOrder.value)
      ? (_openBlock(), _createBlock(CentralLoader, {
          key: 1,
          primaryColor: _unref(restaurant).design_custom?.primary_color,
          zIndex: 999
        }, null, 8, ["primaryColor"]))
      : _createCommentVNode("", true),
    _createVNode(AddressSearchModal, {
      isOpen: isAddressSearchOpen.value,
      savedAddresses: savedAddresses.value,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (isAddressSearchOpen.value = false)),
      onSelect: onAddressSelected,
      onManual: onAddressManual
    }, null, 8, ["isOpen", "savedAddresses"])
  ]))
}
}

})